import { Component, ChangeDetectionStrategy, inject, linkedSignal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { GdprBannerMode, GdprConsent, GdprFacade } from "state/gdpr.facade";
import { toSignal } from "@angular/core/rxjs-interop";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";

import { I18nHtmlComponent } from "components/datadisplays/i18n-html/i18n-html.component";

@Component({
  selector: "app-gdpr-banner",
  templateUrl: "./gdpr-banner.component.html",
  styleUrls: ["./gdpr-banner.component.scss"],
  standalone: true,
  imports: [FormsModule, TranslateModule, I18nHtmlComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GdprBannerComponent {
  public readonly gdprFacade = inject(GdprFacade);
  private readonly sanitizer = inject(DomSanitizer);

  readonly GdprBannerMode = GdprBannerMode;

  readonly consent = toSignal(this.gdprFacade.consent$);
  readonly accepted = toSignal(this.gdprFacade.accepted$);
  readonly mode = toSignal(this.gdprFacade.mode$);

  public readonly functional = linkedSignal<GdprConsent, boolean>({
    source: this.consent,
    computation: (consent) => !!consent?.functional,
  });

  public readonly analytics = linkedSignal<GdprConsent, boolean>({
    source: this.consent,
    computation: (consent) => !!consent?.analytics,
  });

  openSettings() {
    this.gdprFacade.openSettings();
    const current = this.consent();
    this.functional.set(current?.functional ?? false);
    this.analytics.set(current?.analytics ?? false);
  }

  cancel() {
    const current = this.consent();
    this.functional.set(current?.functional ?? false);
    this.analytics.set(current?.analytics ?? false);
    this.gdprFacade.cancel();
  }

  saveConsent() {
    const consent: GdprConsent = {
      functional: this.functional(),
      analytics: this.analytics(),
    };
    this.gdprFacade.saveConsent(consent);
  }
}
